import { render, staticRenderFns } from "./GlassBreakageRoomDamagesCountQuestion.vue?vue&type=template&id=275bdfa1&scoped=true"
import script from "./GlassBreakageRoomDamagesCountQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageRoomDamagesCountQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassBreakageRoomDamagesCountQuestion.vue?vue&type=style&index=0&id=275bdfa1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275bdfa1",
  null
  
)

export default component.exports